import { ScanSubject } from '../type/ScanSubject';

export class ScanInputAction {
  static SCANNED_SUBJECT_PRODUCT: ScanSubject = 'product';

  static SCANNED_SUBJECT_SKU: ScanSubject = 'sku';

  static SCANNED_SUBJECT: ScanSubject = 'other';

  subject: ScanSubject;

  action: (code: string) => void;

  constructor(subject: ScanSubject, action: (code: string) => void) {
    this.subject = subject;
    this.action = action;
  }
}
